import React from 'react';

const Spinner = (props) => {
  return (
    <div className="Spinner" />
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js